import type { CaseStatus } from "./types";

export const CASE_STATUS_LIST: CaseStatus[] = [
  "AWAITING_PAYMENT", "PAYMENT_CONFIRMED", "AWAITING_DOCUMENTS", "DOCUMENTS_UNDER_REVIEW",
  "READY_FOR_INSPECTION", "INSPECTION_SCHEDULED", "INSPECTION_IN_PROGRESS",
  "REPORT_IN_REVIEW", "REPORT_READY", "COMPLETED", "CANCELLED",
];
